/*
  Project: Vivafloors
 */

// The discount code field in the 'Jouw stalen' sidebar, see
// templates/components/order-summary-totals.php. Talks to WooCommerce's own
// apply_coupon/remove_coupon endpoints and then lets update_checkout re-render
// the totals as a fragment (inc/functions/coupons.php). The totals are
// replaced wholesale, so every handler here is delegated.
jQuery(function ($) {
  const params = window.wc_checkout_params;
  if (!params || !document.querySelector('.js-order-summary-totals')) return;

  // header.php and custom_gform_init() in functions.php both load the bundle,
  // so this runs twice. Bound twice, the toggle would open and shut again on
  // the same click.
  if (window.vivafloorsCouponBound) return;
  window.vivafloorsCouponBound = true;

  const endpoint = name => params.wc_ajax_url.toString().replace('%%endpoint%%', name);

  // WooCommerce answers with the rendered notices, in either its classic or
  // its block markup.
  const isError = html => /woocommerce-error|is-error/.test(html);
  const noticeText = html => $('<div>').html(html).text().replace(/\s+/g, ' ').trim();

  const refresh = () => $(document.body).trigger('update_checkout');

  $(document).on('click', '.js-coupon-toggle', function () {
    const $toggle = $(this);
    const open = $toggle.attr('aria-expanded') !== 'true';
    const $form = $('#' + $toggle.attr('aria-controls'));

    $toggle.attr('aria-expanded', String(open));
    $form.prop('hidden', !open);

    if (open) $form.find('.js-coupon-code').trigger('focus');
  });

  const apply = function ($coupon) {
    const $input = $coupon.find('.js-coupon-code');
    const $button = $coupon.find('.js-coupon-apply');
    const $message = $coupon.find('.js-coupon-message');
    const code = String($input.val() || '').trim();

    if (!code || $button.prop('disabled')) return;

    $button.prop('disabled', true);
    $message.prop('hidden', true).text('');

    $.ajax({
      type: 'POST',
      url: endpoint('apply_coupon'),
      data: {
        security: params.apply_coupon_nonce,
        coupon_code: code,
      },
      dataType: 'html',
    }).done(html => {
      if (isError(html)) {
        $message.text(noticeText(html)).prop('hidden', false);
        $input.trigger('focus');
        return;
      }

      refresh();
    }).always(() => {
      $button.prop('disabled', false);
    });
  };

  $(document).on('click', '.js-coupon-apply', function () {
    apply($(this).closest('.js-coupon'));
  });

  // Not a real form: the sidebar sits outside form.checkout and a nested form
  // is not allowed, so Enter is handled here.
  $(document).on('keydown', '.js-coupon-code', function (event) {
    if (event.key !== 'Enter') return;

    event.preventDefault();
    apply($(this).closest('.js-coupon'));
  });

  $(document).on('click', '.js-coupon-remove', function () {
    const $button = $(this);
    if ($button.prop('disabled')) return;

    $button.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: endpoint('remove_coupon'),
      data: {
        security: params.remove_coupon_nonce,
        coupon: $button.data('coupon'),
      },
      dataType: 'html',
    }).always(refresh);
  });
});



// WEBPACK FOOTER //
// ./src/scripts/modules/coupon.js